import RangeChartContainer from './RangeChart'

export {RangeChartContainer}

export default RangeChartContainer
